import { Button } from "@/components/core/buttons/button";
import { Content } from "@/components/layouts/content";
import { SiteForm } from "@/components/sites/site-form";
import { useSiteCreateMutation } from "@/features/dashboard/api/queries/site-query";
import type { Site } from "@/features/dashboard/types/site";
import { Link, createFileRoute, useNavigate } from "@tanstack/react-router";
import { toast } from "sonner";

export const Route = createFileRoute("/_dashboard/sites_/create")({
	component: SiteCreate,
});

function SiteCreate() {
	const siteCreateMutation = useSiteCreateMutation();
	const navigate = useNavigate();

	const handleSubmit = async (values: Site) => {
		try {
			await siteCreateMutation.mutateAsync(values);
			toast.success("Site created successfully");
			navigate({
				to: "/sites",
			});
		} catch (error) {
			toast.error("Failed to create site");
		}
	};

	return (
		<Content>
			<div className="flex flex-col w-full p-4">
				<div className="flex flex-col w-full gap-6">
					<div className="flex flex-row items-center justify-between w-full gap-4">
						<div className="inline-flex flex-col w-auto">
							<span className="text-xl text-foreground-dark font-semibold">Create Site</span>
							<span className="text-base text-foreground/70">Fill up site details below.</span>
						</div>
					</div>

					<SiteForm onSubmit={handleSubmit} isSubmitting={siteCreateMutation.isPending} />

					<div className="col-span-12 flex gap-2">
						<Button type="button" variant="ghost">
							<Link to="/sites">Cancel</Link>
						</Button>
						<Button type="submit" form="site-form" disabled={siteCreateMutation.isPending}>
							{siteCreateMutation.isPending ? "Creating..." : "Create Site"}
						</Button>
					</div>
				</div>
			</div>
		</Content>
	);
}
